module.exports = __webpack_public_path__ + "static/turquia-001-c525d5c7aaa61a224f007f6c0ac9f697.jpg";